import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import * as classNames from "classnames"
import * as React from "react"
import HotTable from "../common/hot-table"
import * as Model from "../../../model"
import TableDefinition from "../admin/table-definition"
import ExcelDownload from "../excelfile"

export default class AdminComponent extends React.Component<Props> {
    render() {
        const firstColWidth = 450
        return <div className="scenario-admin">
            <div className="scenario-detail-header">
                <a
                    className="back-to-list"
                    href="javascript:void()"
                    onClick={this.props.onBack}>
                    <FontAwesomeIcon icon="backward"/>
                </a>

                {this.renderTitle()}

                {this.props.isSuperAdmin &&
                    <p>
                        <button onClick={this.props.onToggleAdmin} className='button'
                                disabled={this.props.isServiceAgent} style={{marginLeft: "10px"}}>Modifier
                        </button>
                    </p>
                }
                <label className="scenario-title">
                    <input
                        type="checkbox"
                        checked={this.props.hideRows}
                        onClick={this.props.onHideRows}/>
                    &nbsp; Cacher les lignes vides
                </label>
                <ExcelDownload props={this.props} show={"admin"} Excel={() => this.props.Excel()}/>
                <p style={{color: "white", paddingLeft: "10px"}}>Pensez à cliquer sur l'icône ✓ pour valider les valeurs
                    saisies.</p>
            </div>

            <div className="tabs-container">
                <div className="tabs">
                    <div
                        className={classNames("tab", {active: this.props.currentTab === "revenues"})}
                        onClick={() => this.props.onTabChange("revenues")}>
                        Recettes
                    </div>

                    <div
                        className={classNames("tab", {active: this.props.currentTab === "spending"})}
                        onClick={() => this.props.onTabChange("spending")}>
                        Dépenses
                    </div>
                </div>

                <div className="panes">
                    <div className="pane active">
                        {!this.props.data.length &&
                            <div className="no-accounts-scenario">Aucun chapitre disponible pour saisir la
                                répartition</div>}
                        <HotTable
                            root="main"
                            title="Articles"
                            firstColWidth={firstColWidth}
                            fixedColumnLeft={this.props.isServiceAgent ? 2 : 3}
                            currentUser={this.props.currentUser}
                            headers={this.props.headers}
                            data={this.props.data}
                            currentTab={this.props.currentTab}
                            scenario={this.props.scenario}
                            tableDefinition={this.props.tableDefinition}
                            themes={this.props.themes}
                            localAuthority={this.props.localAuthority}
                            isServiceAgent={this.props.isServiceAgent}
                            hideRows={this.props.hideRows}
                            onChange={this.props.onChange}
                            onMouseDown={this.props.onMouseDown}
                            onToggleChapter={this.props.onToggleChapter}
                        />
                    </div>
                </div>
            </div>
        </div>
    }

    private renderTitle(): React.ReactNode {
        const number = this.props.scenario.identifier
        const description = this.props.scenario.description
        let label = `${number} - ${description} / Répartition `

        if (!this.props.isAdmin) label += "par gestionnaire pour l'année"

        return <span className="scenario-title">
			{label} <strong>{this.props.scenario.year}</strong>
		</span>
    }
}

interface Coordinates {
    col: number;
    row: number;
}

export interface ChangeData {
    account: Model.Account;
    chapter: Model.Chapter;
    accountIds: number[];
    theme: Model.PpiInvestmentTheme;
    checked: boolean;
}

export interface Props {
    currentTab: TabId;
    data: Data;
    head: string[]
    headers: string[];
    isAdmin: boolean;
    isSuperAdmin: boolean;
    isServiceAgent: boolean;
    scenario: Model.Scenario;
    tableDefinition: ReturnType<typeof TableDefinition>;
    themes: Model.Service[];
    revenues: Data;
    spending: Data;
    revenuesTableDef: any
    spendingTableDef: any
    localAuthority: any
    currentUser: any
    hideRows: boolean

    Excel(): void

    onBack(): void;

    onChange(type: ChangeType, data: ChangeData | Changes): void;

    onMouseDown(coord: Coordinates): void;

    onToggleChapter(chapter: Model.Chapter): void;

    onTabChange(tab: TabId): void;

    onToggleAdmin(): void;

    onHideRows(): void;
}

export type ChangeType = "account_theme" | "main"
export type Changes = [number, number, any, any][]
type DataRow = any[]
type Data = DataRow[]
type TabId = "revenues" | "spending"



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/admin-component.tsx